import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import * as API from "../api/index";
import { ROUTES } from "../../api/routes";
import ConnectionCommandViewTable from "./connectionCommandView";
import { commandColumns, COMMAND_FIELDS_TO_DELETE, toCommandRow } from "../shared/commandColumns";
import BackToolbarLink from "../shared/BackToolbarLink";
import AddToolbarLink from "../shared/AddToolbarLink";
import "../util/tables.css";

const ConnectionCommands = () => {
  const [commandList, setCommandList] = useState([]);
  const navigate = useNavigate();
  const { connectionID } = useParams();

  useEffect(() => {
    API.GetDataFromAPI(ROUTES.fileTransferCmds(connectionID)).then((data) => {
      data.forEach((el) =>
        COMMAND_FIELDS_TO_DELETE.forEach((f) => delete el[f]),
      );
      setCommandList(data);
    });
  }, [connectionID]);

  const dataParams = {
    transferID: connectionID,
    transfer_seq: commandList.length,
  };

  return (
    <div className="relative">

      {commandList.length > 0 ? (
        <ConnectionCommandViewTable
          data={commandList.map(toCommandRow)}
          columns={commandColumns}
          dataParams={dataParams}
        />
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <BackToolbarLink onClick={() => navigate(-1)} />
          <AddToolbarLink to="/AddConnectionCmd" label="Add Command" state={dataParams} />
        </Box>
      )}
    </div>
  );
};

export default ConnectionCommands;
